import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableBody
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CertificadoAtencionAfiliadoBuscador } from './CertificadoAtencionAfiliadoBuscador'
import { OBRAS_SOCIALES } from "../../../../utils/constants";
import { clearReducer, consultarCertificadosPorAfiliado } from "../../../../actions/certificadoAtencion/certificadoAtencionActions";
import { CertificadoAtencionItem } from "./CertificadoAtencionItem";

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
});



export const CertificadoAtencionBusqueda = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado,
    items
  } = useSelector((state) => state.certificadoAtencion);

  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSPEDYC);
  const [rowsPerPage, setRowsPerPage] = useState(20);



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (afiliadoSeleccionado) {
      let afiliado = null;
      let afiliadoExterno = null;

      if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
        afiliado = afiliadoSeleccionado?.id_afiliado;
      } else {
        afiliadoExterno = afiliadoSeleccionado?.id_afiliado;
      }
      dispatch(consultarCertificadosPorAfiliado(afiliado, afiliadoExterno));
    }
    else {
      dispatch(clearReducer());
    }
  }, [afiliadoSeleccionado]);


  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={12}>
            <CertificadoAtencionAfiliadoBuscador idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} hideTitle={true} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell align="left">Fecha</TableCell>
                <TableCell align="left">N° Certificado</TableCell>
                <TableCell align="left">Carnet</TableCell>
                <TableCell align="left">Beneficiario</TableCell>
                <TableCell align="left">Centro Médico</TableCell>
                <TableCell align="left">Especialidad</TableCell>
                <TableCell align="left">Profesional</TableCell>
                <TableCell align="left">Enviar por email</TableCell>
                <TableCell align="left">Imprimir</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                // items.map((item) => (
                items
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <CertificadoAtencionItem
                      item={item}
                      key={item.id?.toString()}
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}

    </Grid>
  )
}
